import { render, staticRenderFns } from "./FormTag.vue?vue&type=template&id=52ea858b&scoped=true&"
import script from "./FormTag.vue?vue&type=script&lang=ts&"
export * from "./FormTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea858b",
  null
  
)

export default component.exports